import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet, Route } from 'react-router';
import { AddTagPage, EditTagPage, TagReorderPage, TagsPage } from '#route-bundles/authenticated.tsx';
import { fallbackRenderNotFound } from '#screens/errors/fallbackRenderNotFound.tsx';
import { LoadingSpinner } from '#screens/loading/LoadingSpinner.tsx';
import { page, Titled } from '#util/title.ts';

/**
 * {@link tagsRootRoute} contains all of the routing config for the /tags path
 */
export const tagsRootRoute = (
  <Route
    element={
      <Titled title={() => page('Tags')}>
        <Suspense fallback={<LoadingSpinner />}>
          <Outlet />
        </Suspense>
      </Titled>
    }
  >
    <Route index={true} element={<TagsPage />} />
    <Route path="add" element={<AddTagPage />} />
    <Route path="reorder" element={<TagReorderPage />} />
    <Route
      path=":tagName"
      element={
        <ErrorBoundary fallbackRender={fallbackRenderNotFound}>
          <EditTagPage />
        </ErrorBoundary>
      }
    />
  </Route>
);
